<template>
  <section class="ON_affiliate_area ON_100px_padding">
    <div class="container">
      <div class="row ON_affiliate_area_inner_list">
        <div class="col-lg-4">
          <div class="ON_area_title_2">
            <h2>Best Product Deals</h2>
          </div>
          <div class="ON_affiliate_list">
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://www.shoutmeloud.com/wp-content/uploads/2009/10/Choose-Best-Affiliate-Product.jpg"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming Product affiliate links
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://www.shoutmeloud.com/wp-content/uploads/2009/10/Choose-Best-Affiliate-Product.jpg"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming Product affiliate links
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://www.shoutmeloud.com/wp-content/uploads/2009/10/Choose-Best-Affiliate-Product.jpg"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming Product affiliate links
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://www.shoutmeloud.com/wp-content/uploads/2009/10/Choose-Best-Affiliate-Product.jpg"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming Product affiliate links
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="ON_area_title_2">
            <h2>Tech Culture</h2>
          </div>
          <div class="ON_affiliate_list">
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://readyspace.com/wp-content/uploads/2019/03/affiliate-W750xH855.png"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming tech partnerships, stay tuned
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://readyspace.com/wp-content/uploads/2019/03/affiliate-W750xH855.png"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming tech partnerships, stay tuned
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://readyspace.com/wp-content/uploads/2019/03/affiliate-W750xH855.png"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming tech partnerships, stay tuned
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://readyspace.com/wp-content/uploads/2019/03/affiliate-W750xH855.png"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming tech partnerships, stay tuned
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="ON_area_title_2">
            <h2>Brilliant Ideas</h2>
          </div>
          <div class="ON_affiliate_list">
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://s3.amazonaws.com/sm-site-media/sm/public/wp-content/uploads/2019/11/05143826/20191205-blog-affiliate_-banner-01-01.png"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming product partnerships, stay tuned
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://s3.amazonaws.com/sm-site-media/sm/public/wp-content/uploads/2019/11/05143826/20191205-blog-affiliate_-banner-01-01.png"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming product partnerships, stay tuned
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://s3.amazonaws.com/sm-site-media/sm/public/wp-content/uploads/2019/11/05143826/20191205-blog-affiliate_-banner-01-01.png"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming product partnerships, stay tuned
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="media">
              <div class="d-flex">
                <img
                  src="https://s3.amazonaws.com/sm-site-media/sm/public/wp-content/uploads/2019/11/05143826/20191205-blog-affiliate_-banner-01-01.png"
                  width="100"
                  height="80"
                  alt=""
                />
              </div>
              <div class="media-body">
                <div class="ON_article_card_text">
                  <a href="#"
                    ><h4>
                      Upcoming product partnerships, stay tuned
                    </h4></a
                  >
                  <div class="date">
                    <a href="#"
                      ><i class="fa fa-calendar" aria-hidden="true"></i
                      >{{ currentDate }}</a
                    >
                    <a href="#"
                      ><i class="fa fa-ad" aria-hidden="true"></i>ad</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {};
  },
  methods: {
    headerCurrentTime: function() {
      this.currentDate = moment().format("dddd, MMMM Do, YYYY");
    }
  },
  created() {
    this.headerCurrentTime();
  }
};
</script>
